import EntryComponent from './subComponents/entry/entry-component'
import FirstComponent from './subComponents/first/first-component'
import SecondComponent from './subComponents/second/second-component'
import ThirdComponent from './subComponents/third/third-component'

export default {
  name: 'connect',
  data: function() {
    return {
      currentComponent: 'entry-component',
      isBlue: true,
      currentQuestionNumber: 1
    }
  },
  components: {
    'entry-component': EntryComponent,
    'first-component': FirstComponent,
    'second-component': SecondComponent,
    'third-component': ThirdComponent
  },
  watch: {
    currentComponent: function() {
      if (this.currentComponent === 'entry-component') {
        this.isBlue = true
      } else {
        this.isBlue = false
      }
    }
  },
  computed: {
    landingText: function() {
      return this.$store.getters.langFile[this.$options.name]
    },
    breadCrumbs: function() {
      return this.$store.getters.langFile['overview']
    },
    legal: function() {
      return this.$store.getters.langFile.legal
    },
    connectText: function() {
      return this.$store.getters.langFile[this.$options.name]
    },
    plan: function() {
      return this.$store.getters.langFile.plan
    },
    overview: function() {
      return this.$store.getters.langFile.overview
    }
  },
  methods: {
    changeComponent: function(newComponent) {
      this.currentComponent = newComponent
      window.scrollTo(0, 0)

      switch (newComponent) {
        case 'first-component':
          this.currentQuestionNumber = 1
          break
        case 'second-component':
          this.currentQuestionNumber = 2
          break
        case 'third-component':
          this.currentQuestionNumber = 3
          break
      }
    },
    goToImprint: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'imprint',
        params: {
          id
        }
      })
    },
    goBack: function() {
      switch (this.currentComponent) {
        case 'first-component':
          this.currentComponent = 'entry-component'
          this.currentQuestionNumber = 1
          break
        case 'second-component':
          this.currentComponent = 'first-component'
          this.currentQuestionNumber = 1
          break
        case 'third-component':
          this.currentComponent = 'second-component'
          this.currentQuestionNumber = 2
          break
      }
    },
    cancelDesktop: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'overview',
        params: {
          id
        }
      })
    },
    cancelMobile: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'landing',
        params: {
          id
        }
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/connect/connect.js